import React from "react";

const LoaderItemFeed = () => {
  return (
    <>
      <div className="loader__feed-container">
        <div className="loader__feed-text" />
        <div className="loader__feed-text" style={{ width: "70%" }} />
        <div className="loader__feed-button-container">
          <div className="loader__feed-text" style={{ width: "70%", height: "16px" }} />
          <div className="loader__feed-button" />
        </div>
        <div className="loader__feed-image" />
      </div>
    </>
  );
};

export default LoaderItemFeed;
